/**
 * The E-Tracker is injected via google tag manager, so we have to check if it exists inside our window element
 */
export class ETracker {
  private trackingElements;

  constructor() {
    this.trackingElements = document.querySelectorAll('.js-dispatchTrackingEvent');
    this.initializeTrackingListeners();
    this.initializeREACHTracking();
  }

  private initializeTrackingListeners(): void {
    [].forEach.call(this.trackingElements, (trackingElement: HTMLElement): void => {
      switch (trackingElement.dataset.action) {
        case 'click':
          trackingElement.addEventListener('click', () => {
            this.dispatchTrackingEvent(trackingElement);
          });
          break;
        default:
      }

    });
  }

  private initializeREACHTracking(): void {
    const resultElement = document.querySelector('.js-ReachSearchResult');
    if (resultElement instanceof HTMLElement && resultElement.dataset.resultState) {
      this.sendREACHEvent(resultElement.dataset.resultState, 0);
    }
  }

  private sendREACHEvent(state: string, iteration: number) {
    if (iteration > 10) {
      return;
    }
    if ('_etracker' in window && 'et_UserDefinedEvent' in window && typeof window.et_UserDefinedEvent !== 'undefined') {
      dispatchUserTrackingEvent('Reach', 'SEARCH', 'Result', state);
    } else {
      window.setTimeout(
        () => {
          this.sendREACHEvent(state, iteration + 1);
        },
        500);
    }
  }

  private dispatchTrackingEvent(trackingElement: HTMLElement): void {
    switch (trackingElement.dataset.event) {
      case 'user-defined':
        dispatchUserTrackingEvent(
          typeof trackingElement.dataset.object !== 'undefined' ? trackingElement.dataset.object : 'no object set',
          typeof trackingElement.dataset.category !== 'undefined' ? trackingElement.dataset.category : 'no category set',
          typeof trackingElement.dataset.action !== 'undefined' ? trackingElement.dataset.action : 'no action set',
          typeof trackingElement.dataset.type !== 'undefined' ? trackingElement.dataset.type : 'no type set',
        );
        break;
      default:
    }
  }
}

export async function dispatchUserTrackingEvent(
  object: string = 'no object set',
  category: string = 'no category set',
  action: string = 'no action set',
  type: string = 'no type set',
) {
  if ('_etracker' in window && 'et_UserDefinedEvent' in window && typeof window.et_UserDefinedEvent !== 'undefined') {
    window._etracker.sendEvent(
      new window.et_UserDefinedEvent(object, category, action, type),
    );
  }
}
